import AdminUserList from "./AdminUserList";


export default function AdminUsers() {
  return (
    <div className="container-fluid">
      <AdminUserList />
    </div>
  )  
}